<nbl-personal-form class="ambita-report-block">
  <h3 class="ambita-nbl-personal-form__heading ambita-report-h3 break-before">Nabovarsel</h3>
  <p>
    <b>Sendes til berørte naboer og gjenboere</b><br>
    plan- og bygningsloven av 27. juni 2008 nr 71 § 21-3
  </p>

  <div style="width: 40%; float: left;">
    <div class="ambita-nbl-personal-form__receiver">
      <sup>Til (nabo/gjenboer)</sup><br>
      {opts.neighbor.name}<br>
      {opts.neighbor.address.title}<br>
      {opts.neighbor.address.postcode} {opts.neighbor.address.city}
    </div>

    <table class="table">
      <thead>
      <tr>
        <th>Som eier/fester av:</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <sup>Gnr.</sup> {opts.neighbor.cadastre.gnr}
          <sup>|Bnr.</sup> {opts.neighbor.cadastre.bnr}
          <sup>|Festenr.</sup> {opts.neighbor.cadastre.fnr}
          <sup>|Seksjonsnr</sup> {opts.neighbor.cadastre.snr}
        </td>
      </tr>
      <tr>
        <td><sup>Eiendommensadresse</sup> {opts.neighbor.cadastreAddress.title}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <div style="width: 40%; float: right;">
    <table class="table">
      <thead>
      <tr>
        <th>Tiltak på eiendommen:</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <sup>Gnr.</sup> {opts.cadastre.gnr}
          <sup>|Bnr.</sup> {opts.cadastre.bnr}
          <sup>|Festenr.</sup> {opts.cadastre.fnr}
          <sup>|Seksjonsnr</sup> {opts.cadastre.snr}
        </td>
      </tr>
      <tr>
      <tr>
        <td><sup>Adresse</sup> {opts.address.title}</td>
      </tr>
      <tr>
        <td>
          <sup>Postnr.</sup> {opts.address.postcode}
          <sup>|Poststed</sup> {opts.address.city}
        </td>
      </tr>
      <tr>
        <td><sup>Kommune</sup> {opts.cadastre.knr}</td>
      </tr>
      <tr>
        <td><sup>Eier/fester</sup> {opts.owner.name}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <nbl-notification-schema prefill-schema="{ opts.prefillSchema }"></nbl-notification-schema>
  <script>
    import './neighborListPersonalForm.scss';
    import './neighborListNotificationSchema.tag';
  </script>
</nbl-personal-form>
